import { visserApi } from './visserApi';
import { convertModelToFormData } from './helpers';
const getAllJobCategories = async () => {
    return await visserApi.get('Job/GetAllJobCategories');
};
const getWorkOrderNumber = async () => {
    return await visserApi.get('workorder/WorkOrderNumber');
};
const getWorkshopLocation = async () => {
    return await visserApi.get('workshoplocation/GetAll');
};
const getWorkOrderById = (workOrderId) => {
    return visserApi.get(`workorder/GetById/${workOrderId}`);
};
const getAllWorkOrdersById = (workOrderId) => {
    return visserApi.get(`workorder/GetAllWorkOrdersById/${workOrderId}`);
};
const getAllObjects = async () => {
    return visserApi.get('Object/GetAll');
};
const getContactPersonsById = (debtorId) => {
    return visserApi.get(`debtor/GetContactPersonsByDebitorId/${debtorId}`);
};
const createWorkOrder = (workOrder) => {
    return visserApi.post('workorder/Create', workOrder);
};
const getAllWorkOrder = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`workorder/GetAll?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const updateWorkOrder = (workOrderId, workOrder) => {
    return visserApi.put(`workorder/Update/${workOrderId}`, workOrder);
};
const getAllAttachmentsByWorkorderId = (workOrderId) => {
    return visserApi.get(`workorder/GetAllAttachmentsByWorkOrderId/${workOrderId}`);
};
const addAttachmentsByWorkorderId = (fileUploaded) => {
    const formData = convertModelToFormData(fileUploaded);
    return visserApi.postForm('workorder/UploadWorkOrderAttachment', formData);
};
const deleteWorkOrderAttachment = (attachmentId) => {
    return visserApi.delete(`workorder/DeleteAttachmentById/${attachmentId}`);
};
const saveWorkOrderNote = (notes) => {
    return visserApi.put(`workorder/SaveWorkOrderNote/${notes.id}`, notes);
};
const getAllWorkOrderStatus = async () => {
    return await visserApi.get('workorder/GetAllWorkOrderStatus');
};
const getAllActiveWorkOrder = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`workorder/GetAllActiveWorkOrder?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllProgressNotesByWorkOrderId = (workOrderId) => {
    return visserApi.get(`workorder/GetAllProgressNotesByWorkOrderId/${workOrderId}`);
};
const saveProgressNotesById = (createWorkOrderNotesDto) => {
    return visserApi.post('workorder/SaveProgressNotesById', createWorkOrderNotesDto);
};
const deleteProgressNotesById = (progressnote) => {
    return visserApi.post('workorder/DeleteProgressNotesById?id', progressnote);
};
const updateWorkorderToUrgent = async (workorderId, updateUrgent) => {
    return await visserApi.put(`workorder/UpdateWorkorderToUrgent/${workorderId}`, updateUrgent);
};
const getOrdersByWorkOrderId = async (workorderId) => {
    return await visserApi.get(`workorder/GetOrdersByWorkOrderId/${workorderId}`);
};
const deleteWorkOrderById = async (id) => {
    return await visserApi.delete(`workorder/Delete/${id}`);
};
const getAllWorkOrdersOnMove = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`workorder/WorkOrdersOnMove?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const updateWorkOrderStatusById = async (updateworkorderStatus) => {
    return await visserApi.put(`workorder/UpdateWorkOrderStatusById`, updateworkorderStatus);
};
const generateDeliveryNotePdf = async (materials) => {
    const response = await visserApi.post(`workorder/GenerateDeliveryNotePdf`, materials);
    return response.data;
};
const generateOtherWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateOtherWerkbonPdf`, data);
    return response.data;
};
const generateMotorReductorWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateMotorReductorWerkbonPdf`, data);
    return response.data;
};
const generatePompWerkbonPdfAsync = async (data) => {
    const response = await visserApi.post(`workorder/GeneratePompWerkbonPdf`, data);
    return response.data;
};
const generateMotorWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateMotorWerkbonPdf`, data);
    return response.data;
};
const generateTrommelmotorWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateTrommelmotorWerkbonPdf`, data);
    return response.data;
};
const generateVentilatorWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateVentilatorWerkbonPdf`, data);
    return response.data;
};
const generateStandardWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateStandardWerkbonPdf`, data);
    return response.data;
};
const getAllEmployeesByLocation = async (locationId) => {
    return await visserApi.get(`workorder/GetAllEmployeesByLocation/${locationId}`);
};
const getAllWorkshopLocationByCurrentEmployee = async () => {
    return await visserApi.get('workshoplocation/GetAllByCurrentEmployee');
};
const generateTerplaatsWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateTerplaatsWerkbonPdf`, data);
    return response.data;
};
const generateSealWerkbonPdf = async (data) => {
    const response = await visserApi.post(`workorder/GenerateSealWerkbonPdf`, data);
    return response.data;
};
const getAllWorkOrdersDetails = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`workorder/WorkOrdersDetails?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const updateModulePermissionsStatus = async (updateworkorderStatus) => {
    return await visserApi.post(`workorder/UpdateModulePermissionsStatus`, updateworkorderStatus);
};
const WorkOrderApi = {
    getAllJobCategories,
    getWorkOrderNumber,
    getWorkshopLocation,
    getWorkOrderById,
    getAllObjects,
    getContactPersonsById,
    createWorkOrder,
    getAllWorkOrder,
    updateWorkOrder,
    getAllAttachmentsByWorkorderId,
    addAttachmentsByWorkorderId,
    deleteWorkOrderAttachment,
    saveWorkOrderNote,
    getAllWorkOrderStatus,
    getAllActiveWorkOrder,
    getAllProgressNotesByWorkOrderId,
    saveProgressNotesById,
    deleteProgressNotesById,
    updateWorkorderToUrgent,
    getOrdersByWorkOrderId,
    deleteWorkOrderById,
    getAllWorkOrdersOnMove,
    updateWorkOrderStatusById,
    generateDeliveryNotePdf,
    generateOtherWerkbonPdf,
    generateMotorReductorWerkbonPdf,
    generatePompWerkbonPdfAsync,
    generateMotorWerkbonPdf,
    generateTrommelmotorWerkbonPdf,
    generateVentilatorWerkbonPdf,
    generateStandardWerkbonPdf,
    getAllEmployeesByLocation,
    getAllWorkshopLocationByCurrentEmployee,
    generateTerplaatsWerkbonPdf,
    generateSealWerkbonPdf,
    getAllWorkOrdersDetails,
    getAllWorkOrdersById,
    updateModulePermissionsStatus
};
export default WorkOrderApi;
